import {
	comMapping
} from "@/components/util/Function/comMapping";

export function getdata() {
	var obj = {
		searchlist: [{
				prop: "nsrmc",
				label: '纳税人名称',
				type: "input"
			},
			{
				prop: "nsrsbh",
				label: '纳税人识别号',
				type: "input"
			},
			{
				prop: "shujly",
				label: '数据来源',
				type: "select",
				selectval: comMapping.$WpsrShujlyMapping
			},
		],
		searchdata: {
			suosq: ""
		},
		headData: [{
				title: "纳税人名称",
				prop: "nsrmc",
				width: 160,
				align: "left"
			},
			{
				title: "纳税人识别号",
				prop: "nsrsbh",
				width: 160,
				align: "left"
			},
			{
				title: "数据来源",
				prop: "shujly",
				width: "100",
				custom: true
			},
			// {
			// 	title: "公司科目名称",
			// 	prop: "companySubjectName",
			// 	width: "200"
			// },
			{
				title: "一般计税方法计税：全部征税项目",
				prop: "",
				children: [{
						title: "13%税率的货物及加工修理修配劳务",
						prop: "",
						children: [{
								title: "销售额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "yibHuowxl13Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "yibHuowxl13Ynse",
								custom: true
							}
						]
					},
					{
						title: "13%税率的服务、不动产和无形资产",
						prop: "",
						children: [{
								title: "销售额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "yibFuwbdcwxzc13Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "yibFuwbdcwxzc13Ynse",
								custom: true
							}
						]
					},
					{
						title: "9%税率的货物及加工修理修配劳务",
						prop: "",
						children: [{
								title: "销售额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "yibHuowxl9Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "yibHuowxl9Ynse",
								custom: true
							}
						]
					},
					{
						title: "9%税率的服务、不动产和无形资产",
						prop: "",
						children: [{
								title: "销售额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "yibFuwbdcwxzc9Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "yibFuwbdcwxzc9Ynse",
								custom: true
							}
						]
					},
					{
						title: "6%税率",
						prop: "",
						children: [{
								title: "销售额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "yibShuil6Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "yibShuil6Ynse",
								custom: true
							}
						]
					},
				]
			},
			{
				title: "简易计税方法计税：全部征税项目",
				prop: "",
				children: [{
						title: "6%征收率",
						prop: "",
						children: [{
								title: "销售额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "jianyZhengsl6Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "jianyZhengsl6Ynse",
								custom: true
							}
						]
					},
					{
						title: "5%征收率的货物及加工修理修配劳务",
						prop: "",
						children: [{
								title: "销售额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "jianyHuowx5Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "jianyHuowx5Ynse",
								custom: true
							}
						]
					},
					{
						title: "5%征收率的服务、不动产和无形资产",
						prop: "",
						children: [{
								title: "销售额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "jianyFuwbdcwxzc5Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "jianyFuwbdcwxzc5Ynse",
								custom: true
							}
						]
					},
					{
						title: "4%征收率",
						prop: "",
						children: [{
								title: "销售额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "jianyZhengsl4Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "jianyZhengsl4Ynse",
								custom: true
							}
						]
					},
					{
						title: "3%征收率的货物及加工修理修配劳务",
						prop: "",
						children: [{
								title: "销售额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "jianyHuowx3Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "jianyHuowx3Ynse",
								custom: true
							}
						]
					},
					{
						title: "3%征收率的服务、不动产和无形资产",
						prop: "",
						children: [{
								title: "销售额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "jianyFuwbdcwxzc3Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "80",
								AmountFormat: true,
								align: "right",
								prop: "jianyFuwbdcwxzc3Ynse",
								custom: true
							}
						]
					},
					{
						title: "预征率",
						prop: "jianyYuzl1Shuil",
						headcustom: true,
						headprop: 'jianyYuzl1Shuil',
						custom: true,
						children: [{
								title: "销售额",
								width: "100",
								AmountFormat: true,
								align: "right",
								prop: "jianyYuzl1Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "100",
								AmountFormat: true,
								align: "right",
								prop: "jianyYuzl1Ynse",
								custom: true
							}
						]
					},
					{
						title: "预征率",
						prop: "jianyYuzl2Shuil",
						headcustom: true,
						headprop: 'jianyYuzl2Shuil',
						custom: true,
						children: [{
								title: "销售额",
								width: "100",
								AmountFormat: true,
								align: "right",
								prop: "jianyYuzl2Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "100",
								AmountFormat: true,
								align: "right",
								prop: "jianyYuzl2Ynse",
								custom: true
							}
						]
					},
					{
						title: "预征率",
						prop: "jianyYuzl3Shuil",
						headcustom: true,
						headprop: 'jianyYuzl3Shuil',
						custom: true,
						children: [{
								title: "销售额",
								width: "100",
								AmountFormat: true,
								align: "right",
								prop: "jianyYuzl3Xse",
								custom: true
							},
							{
								title: "应纳税额",
								width: "100",
								AmountFormat: true,
								align: "right",
								prop: "jianyYuzl3Ynse",
								custom: true
							}
						]
					},
				]
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true,
			}
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		lypagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		headlyData: [{
				title: "映射规则编码",
				prop: "zhangtCode",
				width: "100px"
			},
			{
				title: "相关公司",
				prop: "companyNames",
				custom: true,
				width: 160,
				align: "left"
			},
			{
				title: "数据来源",
				prop: "laiy",
				custom: true,
				width: "350px"
			},
		],
		mxdjInitData: {
			nsrsbh: "",
			suosq: "",
			wpsrId: ""
		},
		tableJson: "{\n" +
			"  \"searchList\":[\n" +
			"    {\n" +
			"      \"name\":\"公司编号\",\n" +
			"      \"column\":\"company_no\",\n" +
			"      \"originName\":\"公司编号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"纳税人名称\",\n" +
			"      \"column\":\"nsrmc\",\n" +
			"      \"originName\":\"纳税人名称\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"纳税人识别号\",\n" +
			"      \"column\":\"nsrsbh\",\n" +
			"      \"originName\":\"纳税人识别号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"数据来源\",\n" +
			"      \"column\":\"shujly\",\n" +
			"      \"originName\":\"数据来源\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"13%税率的货物及加工修理配劳务销售额\",\n" +
			"      \"column\":\"yib_huowxl13_xse\",\n" +
			"      \"originName\":\"13%税率的货物及加工修理配劳务销售额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"13%税率的货物及加工修理配劳务应纳税额\",\n" +
			"      \"column\":\"yib_huowxl13_ynse\",\n" +
			"      \"originName\":\"13%税率的货物及加工修理配劳务应纳税额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"13%税率的服务、不动产和无形资产销售额\",\n" +
			"      \"column\":\"yib_fuwbdcwxzc13_xse\",\n" +
			"      \"originName\":\"13%税率的服务、不动产和无形资产销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"13%税率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"column\":\"yib_fuwbdcwxzc13_ynse\",\n" +
			"      \"originName\":\"13%税率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"9%税率的货物及加工修理配劳务销售额\",\n" +
			"      \"column\":\"yib_huowxl9_xse\",\n" +
			"      \"originName\":\"9%税率的货物及加工修理配劳务销售额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"9%税率的货物及加工修理配劳务应纳税额\",\n" +
			"      \"column\":\"yib_huowxl9_ynse\",\n" +
			"      \"originName\":\"9%税率的货物及加工修理配劳务应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"9%税率的服务、不动产和无形资产销售额\",\n" +
			"      \"column\":\"yib_fuwbdcwxzc9_xse\",\n" +
			"      \"originName\":\"9%税率的服务、不动产和无形资产销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"9%税率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"column\":\"yib_fuwbdcwxzc9_ynse\",\n" +
			"      \"originName\":\"9%税率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"6%税率销售额\",\n" +
			"      \"column\":\"yib_shuil6_xse\",\n" +
			"      \"originName\":\"6%税率销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"6%税率应纳税额\",\n" +
			"      \"column\":\"yib_shuil6_ynse\",\n" +
			"      \"originName\":\"6%税率应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"6%征收率销售额\",\n" +
			"      \"column\":\"jiany_zhengsl6_xse\",\n" +
			"      \"originName\":\"6%征收率销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"6%征收率应纳税额\",\n" +
			"      \"column\":\"jiany_zhengsl6_ynse\",\n" +
			"      \"originName\":\"6%征收率应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    }\n" +
			"\t,\n" +
			"    {\n" +
			"      \"name\":\"5%征收率的货物及加工修理修配劳务销售额\",\n" +
			"      \"column\":\"jiany_huowx5_xse\",\n" +
			"      \"originName\":\"5%征收率的货物及加工修理修配劳务销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"5%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"column\":\"jiany_huowx5_ynse\",\n" +
			"      \"originName\":\"5%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"5%征收率的服务、不动产和无形资产销售额\",\n" +
			"      \"column\":\"jiany_fuwbdcwxzc5_xse\",\n" +
			"      \"originName\":\"5%征收率的服务、不动产和无形资产销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"5%征收率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"column\":\"jiany_fuwbdcwxzc5_ynse\",\n" +
			"      \"originName\":\"5%征收率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"4%征收率销售额\",\n" +
			"      \"column\":\"jiany_zhengsl4_xse\",\n" +
			"      \"originName\":\"4%征收率销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"4%征收率应纳税额\",\n" +
			"      \"column\":\"jiany_zhengsl4_ynse\",\n" +
			"      \"originName\":\"4%征收率应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的货物及加工修理修配劳务销售额\",\n" +
			"      \"column\":\"jiany_huowx3_xse\",\n" +
			"      \"originName\":\"3%征收率的货物及加工修理修配劳务销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"column\":\"jiany_huowx3_ynse\",\n" +
			"      \"originName\":\"3%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"column\":\"jiany_huowx3_ynse\",\n" +
			"      \"originName\":\"3%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的服务、不动产和无形资产销售额\",\n" +
			"      \"column\":\"jiany_fuwbdcwxzc3_xse\",\n" +
			"      \"originName\":\"3%征收率的服务、不动产和无形资产销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"column\":\"jiany_fuwbdcwxzc3_ynse\",\n" +
			"      \"originName\":\"3%征收率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率1税额\",\n" +
			"      \"column\":\"jiany_yuzl1_xse\",\n" +
			"      \"originName\":\"预征率1税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率1应纳税额\",\n" +
			"      \"column\":\"jiany_yuzl1_ynse\",\n" +
			"      \"originName\":\"预征率1应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率2税额\",\n" +
			"      \"column\":\"jiany_yuzl2_xse\",\n" +
			"      \"originName\":\"预征率2税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率2应纳税额\",\n" +
			"      \"column\":\"jiany_yuzl2_ynse\",\n" +
			"      \"originName\":\"预征率2应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率3税额\",\n" +
			"      \"column\":\"jiany_yuzl3_xse\",\n" +
			"      \"originName\":\"预征率3税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率3应纳税额\",\n" +
			"      \"column\":\"jiany_yuzl3_ynse\",\n" +
			"      \"originName\":\"预征率3应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    }\n" +
			"  ],\n" +
			"  \"headData\":[\n" +
			"      {\n" +
			"      \"name\":\"公司编号\",\n" +
			"      \"column\":\"company_no\",\n" +
			"      \"originName\":\"公司编号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"纳税人名称\",\n" +
			"      \"column\":\"nsrmc\",\n" +
			"      \"originName\":\"纳税人名称\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"纳税人识别号\",\n" +
			"      \"column\":\"nsrsbh\",\n" +
			"      \"originName\":\"纳税人识别号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"数据来源\",\n" +
			"      \"column\":\"shujly\",\n" +
			"      \"originName\":\"数据来源\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"13%税率的货物及加工修理配劳务销售额\",\n" +
			"      \"column\":\"yib_huowxl13_xse\",\n" +
			"      \"originName\":\"13%税率的货物及加工修理配劳务销售额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"13%税率的货物及加工修理配劳务应纳税额\",\n" +
			"      \"column\":\"yib_huowxl13_ynse\",\n" +
			"      \"originName\":\"13%税率的货物及加工修理配劳务应纳税额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"13%税率的服务、不动产和无形资产销售额\",\n" +
			"      \"column\":\"yib_fuwbdcwxzc13_xse\",\n" +
			"      \"originName\":\"13%税率的服务、不动产和无形资产销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"13%税率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"column\":\"yib_fuwbdcwxzc13_ynse\",\n" +
			"      \"originName\":\"13%税率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"9%税率的货物及加工修理配劳务销售额\",\n" +
			"      \"column\":\"yib_huowxl9_xse\",\n" +
			"      \"originName\":\"9%税率的货物及加工修理配劳务销售额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"9%税率的货物及加工修理配劳务应纳税额\",\n" +
			"      \"column\":\"yib_huowxl9_ynse\",\n" +
			"      \"originName\":\"9%税率的货物及加工修理配劳务应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"9%税率的服务、不动产和无形资产销售额\",\n" +
			"      \"column\":\"yib_fuwbdcwxzc9_xse\",\n" +
			"      \"originName\":\"9%税率的服务、不动产和无形资产销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"9%税率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"column\":\"yib_fuwbdcwxzc9_ynse\",\n" +
			"      \"originName\":\"9%税率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"6%税率销售额\",\n" +
			"      \"column\":\"yib_shuil6_xse\",\n" +
			"      \"originName\":\"6%税率销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"6%税率应纳税额\",\n" +
			"      \"column\":\"yib_shuil6_ynse\",\n" +
			"      \"originName\":\"6%税率应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"6%征收率销售额\",\n" +
			"      \"column\":\"jiany_zhengsl6_xse\",\n" +
			"      \"originName\":\"6%征收率销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"6%征收率应纳税额\",\n" +
			"      \"column\":\"jiany_zhengsl6_ynse\",\n" +
			"      \"originName\":\"6%征收率应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    }\n" +
			"\t,\n" +
			"    {\n" +
			"      \"name\":\"5%征收率的货物及加工修理修配劳务销售额\",\n" +
			"      \"column\":\"jiany_huowx5_xse\",\n" +
			"      \"originName\":\"5%征收率的货物及加工修理修配劳务销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"5%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"column\":\"jiany_huowx5_ynse\",\n" +
			"      \"originName\":\"5%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"5%征收率的服务、不动产和无形资产销售额\",\n" +
			"      \"column\":\"jiany_fuwbdcwxzc5_xse\",\n" +
			"      \"originName\":\"5%征收率的服务、不动产和无形资产销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"5%征收率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"column\":\"jiany_fuwbdcwxzc5_ynse\",\n" +
			"      \"originName\":\"5%征收率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"4%征收率销售额\",\n" +
			"      \"column\":\"jiany_zhengsl4_xse\",\n" +
			"      \"originName\":\"4%征收率销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"4%征收率应纳税额\",\n" +
			"      \"column\":\"jiany_zhengsl4_ynse\",\n" +
			"      \"originName\":\"4%征收率应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的货物及加工修理修配劳务销售额\",\n" +
			"      \"column\":\"jiany_huowx3_xse\",\n" +
			"      \"originName\":\"3%征收率的货物及加工修理修配劳务销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"column\":\"jiany_huowx3_ynse\",\n" +
			"      \"originName\":\"3%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"column\":\"jiany_huowx3_ynse\",\n" +
			"      \"originName\":\"3%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的服务、不动产和无形资产销售额\",\n" +
			"      \"column\":\"jiany_fuwbdcwxzc3_xse\",\n" +
			"      \"originName\":\"3%征收率的服务、不动产和无形资产销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"column\":\"jiany_fuwbdcwxzc3_ynse\",\n" +
			"      \"originName\":\"3%征收率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率1税额\",\n" +
			"      \"column\":\"jiany_yuzl1_xse\",\n" +
			"      \"originName\":\"预征率1税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率1应纳税额\",\n" +
			"      \"column\":\"jiany_yuzl1_ynse\",\n" +
			"      \"originName\":\"预征率1应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率2税额\",\n" +
			"      \"column\":\"jiany_yuzl2_xse\",\n" +
			"      \"originName\":\"预征率2税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率2应纳税额\",\n" +
			"      \"column\":\"jiany_yuzl2_ynse\",\n" +
			"      \"originName\":\"预征率2应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率3税额\",\n" +
			"      \"column\":\"jiany_yuzl3_xse\",\n" +
			"      \"originName\":\"预征率3税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率3应纳税额\",\n" +
			"      \"column\":\"jiany_yuzl3_ynse\",\n" +
			"      \"originName\":\"预征率3应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    }\n" +
			"  ],\n" +
			"  \"formlist\":[\n" +
			"     {\n" +
			"      \"name\":\"公司编号\",\n" +
			"      \"column\":\"company_no\",\n" +
			"      \"originName\":\"公司编号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"纳税人名称\",\n" +
			"      \"column\":\"nsrmc\",\n" +
			"      \"originName\":\"纳税人名称\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"纳税人识别号\",\n" +
			"      \"column\":\"nsrsbh\",\n" +
			"      \"originName\":\"纳税人识别号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"数据来源\",\n" +
			"      \"column\":\"shujly\",\n" +
			"      \"originName\":\"数据来源\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"13%税率的货物及加工修理配劳务销售额\",\n" +
			"      \"column\":\"yib_huowxl13_xse\",\n" +
			"      \"originName\":\"13%税率的货物及加工修理配劳务销售额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"13%税率的货物及加工修理配劳务应纳税额\",\n" +
			"      \"column\":\"yib_huowxl13_ynse\",\n" +
			"      \"originName\":\"13%税率的货物及加工修理配劳务应纳税额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"13%税率的服务、不动产和无形资产销售额\",\n" +
			"      \"column\":\"yib_fuwbdcwxzc13_xse\",\n" +
			"      \"originName\":\"13%税率的服务、不动产和无形资产销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"13%税率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"column\":\"yib_fuwbdcwxzc13_ynse\",\n" +
			"      \"originName\":\"13%税率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"9%税率的货物及加工修理配劳务销售额\",\n" +
			"      \"column\":\"yib_huowxl9_xse\",\n" +
			"      \"originName\":\"9%税率的货物及加工修理配劳务销售额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"9%税率的货物及加工修理配劳务应纳税额\",\n" +
			"      \"column\":\"yib_huowxl9_ynse\",\n" +
			"      \"originName\":\"9%税率的货物及加工修理配劳务应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"9%税率的服务、不动产和无形资产销售额\",\n" +
			"      \"column\":\"yib_fuwbdcwxzc9_xse\",\n" +
			"      \"originName\":\"9%税率的服务、不动产和无形资产销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"9%税率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"column\":\"yib_fuwbdcwxzc9_ynse\",\n" +
			"      \"originName\":\"9%税率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"6%税率销售额\",\n" +
			"      \"column\":\"yib_shuil6_xse\",\n" +
			"      \"originName\":\"6%税率销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"6%税率应纳税额\",\n" +
			"      \"column\":\"yib_shuil6_ynse\",\n" +
			"      \"originName\":\"6%税率应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"6%征收率销售额\",\n" +
			"      \"column\":\"jiany_zhengsl6_xse\",\n" +
			"      \"originName\":\"6%征收率销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"6%征收率应纳税额\",\n" +
			"      \"column\":\"jiany_zhengsl6_ynse\",\n" +
			"      \"originName\":\"6%征收率应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    }\n" +
			"\t,\n" +
			"    {\n" +
			"      \"name\":\"5%征收率的货物及加工修理修配劳务销售额\",\n" +
			"      \"column\":\"jiany_huowx5_xse\",\n" +
			"      \"originName\":\"5%征收率的货物及加工修理修配劳务销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"5%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"column\":\"jiany_huowx5_ynse\",\n" +
			"      \"originName\":\"5%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"5%征收率的服务、不动产和无形资产销售额\",\n" +
			"      \"column\":\"jiany_fuwbdcwxzc5_xse\",\n" +
			"      \"originName\":\"5%征收率的服务、不动产和无形资产销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"5%征收率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"column\":\"jiany_fuwbdcwxzc5_ynse\",\n" +
			"      \"originName\":\"5%征收率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"4%征收率销售额\",\n" +
			"      \"column\":\"jiany_zhengsl4_xse\",\n" +
			"      \"originName\":\"4%征收率销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"4%征收率应纳税额\",\n" +
			"      \"column\":\"jiany_zhengsl4_ynse\",\n" +
			"      \"originName\":\"4%征收率应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的货物及加工修理修配劳务销售额\",\n" +
			"      \"column\":\"jiany_huowx3_xse\",\n" +
			"      \"originName\":\"3%征收率的货物及加工修理修配劳务销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"column\":\"jiany_huowx3_ynse\",\n" +
			"      \"originName\":\"3%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"column\":\"jiany_huowx3_ynse\",\n" +
			"      \"originName\":\"3%征收率的货物及加工修理修配劳务应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的服务、不动产和无形资产销售额\",\n" +
			"      \"column\":\"jiany_fuwbdcwxzc3_xse\",\n" +
			"      \"originName\":\"3%征收率的服务、不动产和无形资产销售额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"3%征收率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"column\":\"jiany_fuwbdcwxzc3_ynse\",\n" +
			"      \"originName\":\"3%征收率的服务、不动产和无形资产应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率1税额\",\n" +
			"      \"column\":\"jiany_yuzl1_xse\",\n" +
			"      \"originName\":\"预征率1税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率1应纳税额\",\n" +
			"      \"column\":\"jiany_yuzl1_ynse\",\n" +
			"      \"originName\":\"预征率1应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率2税额\",\n" +
			"      \"column\":\"jiany_yuzl2_xse\",\n" +
			"      \"originName\":\"预征率2税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率2应纳税额\",\n" +
			"      \"column\":\"jiany_yuzl2_ynse\",\n" +
			"      \"originName\":\"预征率2应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率3税额\",\n" +
			"      \"column\":\"jiany_yuzl3_xse\",\n" +
			"      \"originName\":\"预征率3税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"预征率3应纳税额\",\n" +
			"      \"column\":\"jiany_yuzl3_ynse\",\n" +
			"      \"originName\":\"预征率3应纳税额\",\n" +
			"      \"show\":\"0\"\n" +
			"    }\n" +
			"  ]\n" +
			"}"
	}
	return obj
}
